<template>
  <el-dialog :visible="visible" title="合同历史" @close="close" width="80%">
    <el-table :data="history">
      <el-table-column prop="id" label="合同编号" align="center" width="250">
        <template v-slot="{ row }">
          <span>{{ `${row.contractNo}-${row.contractVersion}` }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="合同类型" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" v-if="false">
        <template v-slot="{ row }">
          {{ row.detailStatus | convertContractStatus }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" align="center" width="100">
        <template v-slot="{ row }">
          <span>{{ row.updateTime | dataFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operation" label="操作人" align="center">
        <template v-slot="{ row }">
          <span>{{ row.operation || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="{ row, $index }">
          <span
            v-if="
              $index === 0 &&
                [CONTRACT_STATUS.INIT.key, CONTRACT_STATUS.SELLER_UNSIGNED.key].includes(
                  row.detailStatus
                ) &&
                canSign
            "
            class="operate-button"
            @click="toSign"
          >
            在线签署
          </span>
          <!-- <span v-if="row.fileKey" class="operate-button" @click="toView(row.fileKey)">
            下载合同
          </span> -->
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { CONTRACT_STATUS } from '@/common/constants/index'

export default {
  name: 'OrderContractInfo',
  props: {
    visible: {
      type: Boolean
    },
    history: {
      type: Array,
      default: () => []
    },
    canSign: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      CONTRACT_STATUS
    }
  },
  filters: {
    convertContractStatus(status) {
      switch (status) {
        case 1:
          return '卖家未签约'
        case 2:
          return '买家未签约'
        case 3:
          return '已撤销'
        case 4:
          return '双方已签约'
        default:
          return ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    toView(key) {
      this.$emit('view-contract', key)
    },
    toSign() {
      this.$emit('sign-contract')
    }
  }
}
</script>

<style lang="stylus" scoped>
.operate-button
  cursor pointer
</style>
